<div class="filter-section">
  <ion-button
    class="usf-outline-green-button open-filters"
    data-cy="usf-filtering-banner-open-filters-button"
    [fill]="
      numberOfSelectedFilters > 0
        ? 'usf-fill-green-button'
        : 'usf-outline-green-button'
    "
    (click)="openFilterModal()"
  >
    <ion-icon slot="start" name="filter"></ion-icon>
    {{ 'i18n.common.filter' | translate }}
    <ng-container *ngIf="numberOfSelectedFilters > 0"
      >({{ numberOfSelectedFilters }})</ng-container
    >
  </ion-button>
</div>
